import React from 'react';

import List from './List';

const Ul: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => <List as="ul">{children}</List>;

export default Ul;
